import Exception from './Exception'

function Exception403() {
  return <Exception type="403" />
}

export default Exception403
